export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant02-de.adc07068.png";